<template>
  <div>
    <div v-if="state == 'list'">
      <button class="mylisting-button dark-button mb-5" @click="postState()">Post Event</button>
      <!-- <router-link :to="{name: 'Job Board'}" class="" style="display: block;">Job Board</router-link> -->
      <h2 class="dashboard-heading">Manage Events</h2>
      <hr>
      <app-list :listings="listings" @editListing="editListing($event)"></app-list>
      <div class="mt-4">
        <router-link :to="{name: 'Events'}" class="mylisting-button dark-button">Event Board</router-link>
      </div>
    </div>

    <div v-if="state == 'post'">
      <h2 class="dashboard-heading">Post New Event</h2>
      <hr>
      <p class="mt-3" style="cursor: pointer;" @click="cancelPost()">Cancel Post</p>
      <app-form :userID="userID" :listingID="null" @eventPosted="listingPosted()"></app-form>
      <!-- <button class="mylisting-button dark-button mb-5" @click="postJob()">Post Opportunity</button> -->
      <p class="mt-3" style="cursor: pointer;" @click="cancelPost()">Cancel Post</p>
    </div>

    <div v-if="state == 'edit' && listingToEdit.id">
      <h2 class="dashboard-heading">Edit - {{ listingToEdit.title }}</h2>
      <hr>
      <p class="mt-3" style="cursor: pointer;" @click="cancelEdit()">Cancel Edit</p>
      <app-form :userID="userID" :listingID="listingToEdit.id" @eventUpdated="listingUpdated()"></app-form>
      <p class="mt-3" style="cursor: pointer;" @click="cancelEdit()">Cancel Edit</p>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

import List from './EventList';
import Form from './EventForm';

export default {
  props: ['userID'],
  data() {
    return {
      state: 'list',
      listingToEdit: {},
      listings: [],
    }
  },
  components: {
    appList: List,
    appForm: Form,
  },
  created() {
    this.getListings()

    // Scroll the window back up after saving the step
    window.scrollTo(0,0); // https://stackoverflow.com/questions/50449123/vue-js-scroll-to-top-of-page-for-same-route
  },
  methods: {
    getListings() {
      axios.get('/api/events/?poster='.concat(this.userID))
        .then(res => {
          console.log('Got my events')
          console.log(res)
          this.listings = res.data
        })
        .catch(error => console.log(error))
    },
    postState() {
      this.state = 'post'
    },
    cancelPost() {
      this.state = 'list'
    },
    listingPosted() {
      this.state = 'list'
      this.getListings()

      // Scroll the window back up after saving the step
      window.scrollTo(0,0); // https://stackoverflow.com/questions/50449123/vue-js-scroll-to-top-of-page-for-same-route
    },
    editListing(listing) {
      console.log(listing)
      this.listingToEdit = listing
      this.state = 'edit'
    },
    listingUpdated() {
      this.state = 'list'
      this.listingToEdit = {}
      this.getListings()

      // Scroll the window back up after saving the step
      window.scrollTo(0,0); // https://stackoverflow.com/questions/50449123/vue-js-scroll-to-top-of-page-for-same-route
    },
    cancelEdit() {
      this.state = 'list'
      this.listingToEdit = {}
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/events/MyEvents.vue